export default "__VITE_ASSET__CLR93np3__"